
<template>
	<div class="head-nav-wrap">
		<template v-if="!isCoolart">
			<div i="login_nav" class="login-nav" v-if="(($store.state.app.nav_type === 5 || $store.state.app.nav_type === 7) && isLogin === 1) || ($store.state.app.nav_type === 6 && isMediaLogin === 1) || ($store.state.app.nav_type === 8 && isArtLogin === 1)">
				<span class="name">欢迎，{{nickname}}</span>
				<p class="nav-box">
					<span class="nav" @click="logOut()"><span>注销</span></span>
					<span class="nav" v-if="$store.state.app.nav_type === 8 && urls !== '/modify'" @click="message()"><span>客服</span></span>
					<span class="nav" @click="modify()"><span>修改密码</span></span>
					<span class="nav" v-if="$store.state.app.nav_type === 8" @click="toUrl('/coolart/my/cart', {tabIndex: 7})"><span>购物车 {{$store.state.app.num > 0 ? $store.state.app.num : ''}}</span></span>
				</p>
			</div>
			<div i="navigation" class="clearfix">
				<div class="n-logo pull-left">
					<img src="/static/images/logo.png" />
				</div>
				<div class="n-nav-wrap clearfix">
					<div class="nav" :class="{'active': $store.state.app.nav_type === index + 1 }" v-for="(item,index) in list" :key="index">
						<div @click="toLink(item.id)">{{item.name}}</div>
						<ul class="two-ul" v-if="item.children">
							<li v-for="(i,k) in item.children" :key="k" >
								<div @click="toLink(i.id)">{{i.name}}</div>
								<ul class="child" v-if="i.children">
									<li v-for="(x,y) in i.children" :key="y" @click="toLink(x.id)">{{x.name}}
										<ul class="last-child" v-if="x.children">
											<li  v-for="(q, w) in x.children" :key="w">{{q.name}}</li>
										</ul>
									</li>
								</ul>
							</li>
						</ul>
					</div>
				</div>
				<div class="n-right-btn" @click="toUrl('/solicitation/personal/index')" @mouseover="hover(1)"  @mouseout="hover(2)">
					<div class="btn-gif stop" ></div><div class="text">用户登录</div>
				</div>
				<div class="sponsor" v-if="data.cover">
					<a :href="data.url" target="view_window">
						<img :src="data.cover" />
					</a>
				</div>
			</div>
		</template>
		<template v-else>
			<div i="coolart_nav">
				<div class="c-nav-box">
					<span class="nav" @click="toUrl('/login', {type: 2, callback: $route.fullPath})" v-if="isArtLogin == 0"><span>登录</span></span>
					<span class="nav" @click="logOut()" v-if="$store.state.app.nav_type === 8 && isArtLogin > 0"><span>注销</span></span>
					<!-- <span class="nav" @click="vip()" v-if="isArtLogin > 0 && points_type != 2"><span>续费</span></span> -->
					<span class="nav" @click="message()"><span>客服</span></span>
					<span class="nav" @click="service_pop = true"><span>我们的服务</span></span>
					<span class="nav" @click="modify()" v-if="$store.state.app.nav_type === 8 && isArtLogin > 0"><span>修改密码</span></span>
					<span class="nav" @click="galleryFn('/solicitation/personal/index', {gallery: 1})" v-if="$store.state.app.nav_type === 8"><span>艺库收录</span></span>
				</div>
				<div class="n-nav-wrap clearfix">
					<div class="navs" :class="{'active': tabIndex === index}" v-for="(item,index) in coolart_list" :key="index">
						<div @click="go(item, index)">{{item.name}}</div>
						<div class="two-ul">
							<ul class="uls" v-if="item.children">
								<li v-for="(i,k) in item.children" :key="k">
									<div @click="go(i, index)" v-if="i.isHide !== 1">{{i.name}}</div>
									<ul class="child" v-if="i.children">
										<li v-for="(x,y) in i.children" :key="y" @click="go(x, index)" v-if="x.isHide !== 1">{{x.name}}
											<ul class="last-child" v-if="x.children">
												<li  v-for="(q, w) in x.children" v-if="q.isHide !== 1" :key="w">{{q.name}}</li>
											</ul>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</template>

		<div class="alert" v-if="popup">
			<el-dialog :visible.sync="popup" title="" :close-on-click-modal="false" @before-close="close()">
				<p class="text-center f20">客服电话</p>
				<p class="text-center f24 fb mt20">020-37650387</p>
				<p class="text-center f24 fb mt10">020-37650521</p>
				<p class="text-center mt20">请在工作时间拨打：周一至周五 9:30-12:00，14:00-17:30</p>
				<p class="text-center mt10">非工作时间请在下方留言，工作人员将在工作日尽快回电。</p>
				<textarea class="textarea mt20" v-model.trim="content" placeholder="请留下你的问题，我们的工作人员会尽快回复您！"></textarea>
				<div slot="footer" class="dialog-footer text-center">
					<!-- <el-button @click="close()">取 消</el-button> -->
					<el-button class="btn comfrin" type="primary" @click="submit()">确 定</el-button>
					<!-- <el-button class="btn check_idea" type="cancel" @click="submit()">我们的服务</el-button> -->
					<div class="p10"><span class="chat-btn" @click="toUrl('/coolart/my/history'), popup = false">沟通记录</span></div>
				</div>
			</el-dialog>
		</div>
		<div class="service" v-if="service_pop">
			<el-dialog :visible.sync="service_pop" title="" :close-on-click-modal="false" @before-close="close()">
				<div class="textarea mt20" v-html="service_content"></div>
			</el-dialog>
		</div>
	</div>
</template>
<style rel="stylesheet/scss" lang="scss">
	@import '../assets/sass/common/navigation.scss';
</style>
<script>
	import Vue from 'vue';
	import { Dialog, Button } from 'element-ui';
	Vue.use(Dialog);
	Vue.use(Button);
	export default {
		data() {
			return {
				points_type: tools.cache.get('points_type'),
				type: Number(tools.url.params('type')),
				tabIndex: Number(tools.url.params('tabIndex')),
				isLogin: Number(tools.cache.get('isLogin')),
				isArtLogin: Number(tools.cache.get('isArtLogin')),
				isMediaLogin: Number(tools.cache.get('isMediaLogin')),
				nickname: tools.cache.get('nickname'),
				show: false,
				list: [],
				data:{},
				url: location.pathname + location.search,
				urls: location.pathname,
				popup: false,
				service_pop: false,
				content: '',
				service_content: '',
				coolart_list: [{
					name: '大艺博',
					url: '/'
				},{
					name: '艺库首页',
					url: '/coolart/index'
				},{
					name: '作品库',
					url: '/coolart/goods/list',
					isSech: 1
				},{
					name: '优选',
					children: [{
						name: '优选作品',
						url: '/coolart/goods/list',
						query: {is_quarter: 1},
						isSech: 1
					},{
						name: '封面人物',
						url:'/coolart/preference/weekstar'

					},{
						name: '365星计划',
						url:'/coolart/preference/uart'
					},{
						name: '一周新品',
						url: '/coolart/goods/list',
						query: {click: 1},
						isSech: 1
					},{
						name: '超值之选',
						url: '/coolart/goods/list',
						query: {super_good: 1},
						isSech: 1
					}]
				},
				/* {
					name: '场景',
					children: []
				}, */
				{
					name: '近期主题',
					url: '/coolart/theme/list'
				},{
					name: '艺库合作',//空间解决方案
					url: '/coolart/scheme/list'
				},{
					name: '我的艺库',
					children: [{
						name: '购物车',
						url: '/coolart/my/cart'
					},{
						name: '我的订单',
						url: '/coolart/my/order'
					},
					/* {
						name: '我的积分',
						url: '/coolart/my/integral',
						isHide: tools.cache.get('points_type') == 2 ? 0 : 1
					}, */
					{
						name: '我的作品',
						url: '/coolart/my/works',
						isHide: tools.cache.get('points_type') == 2 ? 0 : 1
					},{
						name: '我的评价',
						url: '/coolart/my/comment',
					},{
						name: '我的收藏',
						url: '/coolart/my/stars'
					}]
				}]
			}
		},
		props: {
			isCoolart: {   // 是否为ip艺库
				type: Boolean,
				default: false
			}
		},
		computed: {

		},
		methods: {
			galleryFn(url, data) {
				if (tools.cache.get('isArtLogin') == 1 && tools.cache.get('isLogin') == 1) {
					this.toUrl(url, data)
				}
				else {
                    let fullPath = tools.url.replaceParamVals(data, url)
					this.toUrl('/login', {type: 2, callback: fullPath})
				}
            },

			vip() {
				let that = this;

				that.$store.state.app.vip_popup = true
				that.$store.state.app.is_repay = 1;
				that.$store.state.app.vip_phone = tools.cache.get('phone');
			},

			close() {
				this.popup = false;
			},

			submit() {
				let that = this;

				if (that.content === '') {
					tools.alert.error('请填写留言');
					return
				}

				tools.ajax({
					url: '/api/gallery/designer/message',
					ajaxData: {
						content: that.content,
						message_type: 1
					},
					isLoading: true,
					successFun: function (res) {
						tools.alert.success('留言成功');
						that.popup = false;
					},
					errorFun: function (error_data, status, headers, error_obj) {
						tools.alert.error(error_data.error_msg);
					},
					type: 'POST'
				});

			},

			message() {
				let that = this;
				if (that.isCoolart && that.isArtLogin == 0) {
					that.toUrl('/login', {type: 2, callback: that.$route.fullPath})
					return
				}
				that.popup = true;
			},
			hover(type){
				if(type==1){
					this.show = true;
				}else{
					this.show = false;
				}
			},
			getData() {
                let that = this;
                tools.ajax({
                    url: '/api/banneres',
                    ajaxData: {},
                    successFun: function (res) {
						if (res && res.list && res.list.length > 0) {
                        	that.data = res.list[0];
						}
                    },
                    errorFun: function (error_data, status, headers, error_obj) {
                        tools.alert.error(error_data.error_msg);
                    },
                    type: 'GET'
                });
            },
			toLink(type){
				let that = this;

				if (that.isCoolart) {

					return;
				}
				switch(Number(type)) {
					case 3:
						that.toUrl('/art/introduce');
						break;
					case 6:
						that.toUrl('/art/rater');
						break;
					case 7:
						that.toUrl('/art/list');
						break;
					case 8:
						that.toUrl('/art/study');
						break;
					case 12:
						that.toUrl('/free/more');
						break;
					case 13:
						that.toUrl('/free/list');
						break;
					case 14:
						that.toUrl('/free/artist');
						break;
					case 15:
						that.toUrl('/free/footerbar');
						break;
					case 4:
						that.toUrl('/art/epitome', {type: 1});
						break;
					case 5:
						that.toUrl('/art/epitome', {type: 2});
						break;
					case 20:
						that.toUrl('/solicitation/index');
						break;
					case 17:
						that.toUrl('/media/download');
						that.$store.state.app.active = 1;
						break;
					case 18:
						that.toUrl('/media/download',{type: 2});
						that.$store.state.app.active = 2;
						break;
					case 21:
						that.toUrl('/login');
						break;
					case 22:
						that.toUrl('/solicitation/personal/index');
						break;
					case 1:
						that.toUrl('/');
						break;
					case 2:
						that.toUrl('/art/index');
						break;
					case 9:
						that.toUrl('/works/index');
						break;
					case 10:
						that.toUrl('/participatingartists/index');
						break;
					case 11:
						that.toUrl('/free/index');
						break;
					case 16:
						that.toUrl('/media/download');
						break;
					case 19:
						that.toUrl('/solicitation/index');
						break;
					case 23:
						that.toUrl('/poster');
						break;
					case 29:
						that.toUrl('/about',{type: 9});
						break;
					case 25:
						that.toUrl('/poster');
						break;
					case 26:
						that.toUrl('/coolart/scheme/list', {tabIndex: 6});
						break;
					case 27:
						that.toUrl('/coolart/my/cart', {tabIndex: 7});
						break;
					case 28:
						that.toUrl('/coolart/my/order', {tabIndex: 7});
						break;
					case 30:
						that.toUrl('/solicitation/subject');
						break;
				}
			},

			go (data, index) {
				if (!data.url) {
					return;
				}
				if (data.isSech) {
					tools.cache.set('isSech', 1);
				}
				this.toUrl(data.url, Object.assign({tabIndex: index === 0 ? undefined : index}, data.query));
			},

			getList() {
				let that = this;
				tools.alert.loading();
				tools.ajax({
					url: '/api/navigation/bars',
					ajaxData: {},
					successFun: function(res) {
						window.navList = res.list;
						that.list = res.list;
						//that.list.pop(); /* 删除黄山写生季页面 */
						tools.alert.closeLoading();
					},
					errorFun: function(error_data, status, headers, error_obj) {
						tools.alert.closeLoading();
						tools.alert.error(error_data.error_msg);
					},
					type: 'GET'
				});
			},
			getServiceContent() {
				let that = this;
				tools.alert.loading();
				tools.ajax({
					url: '/api/gallery/instruction',
					ajaxData: {},
					successFun: function(res) {
						console.log(res.value)
						that.service_content = res.data.value;
						tools.alert.closeLoading();
					},
					errorFun: function(error_data, status, headers, error_obj) {
						tools.alert.closeLoading();
						tools.alert.error(error_data.error_msg);
					},
					type: 'GET'
				});
			},
			/* 注销登录 */
            logOut: function () {
				let that = this;

				let url = '';
				if (that.$store.state.app.nav_type === 5 || that.$store.state.app.nav_type === 7) {
					url = '/api/artist/logouts';
				}
				else if (that.$store.state.app.nav_type === 6) {
					url = '/api/media/logouts';
				}
				else {
					url = '/api/gallery/designer/logouts';
				}

                tools.ajax({
                    url: url,
					ajaxData: {},
					isLoading: true,
                    successFun: function (res) {
						let type = 0;
						if (that.$store.state.app.nav_type === 5 || that.$store.state.app.nav_type === 7) {
							window.tools.cache.del('nickname');
                        	window.tools.cache.del('isLogin');
						}
						else if (that.$store.state.app.nav_type === 6) {
							window.tools.cache.del('isMediaLogin');
                			window.tools.cache.del('mediakname');
							type = 1;
						}
						else {
							window.tools.cache.del('isArtLogin');
                			window.tools.cache.del('artkname');
							type = 2;
						}

						location.reload();
                        // that.toUrl('/login', {callback: location.pathname + location.search, type: type});
                    },
                    errorFun: function (error_data, status, headers, error_obj) {
                        tools.alert.error(error_data.error_msg);
                    },
                    type: 'POST'
                });

			},

			modify() {
				let that = this;
				let type = 0;

				if (that.$store.state.app.nav_type === 6) {
					type = 1;
				}
				else {
					type = 2;
				}
				that.toUrl('/modify', {callback: that.url, type: type})
			},

			isLinkChange () {
				let that = this;
				that.isLogin = Number(tools.cache.get('isLogin'));
				that.tabIndex = Number(tools.url.params('tabIndex'));
				that.isArtLogin = Number(tools.cache.get('isArtLogin'));
				that.isMediaLogin = Number(tools.cache.get('isMediaLogin'));
				that.url = location.pathname + location.search;
				that.urls = location.pathname;

				if (that.$store.state.app.nav_type === 5 || that.$store.state.app.nav_type === 7) {
					that.nickname = tools.cache.get('nickname');
				}
				else if (that.$store.state.app.nav_type === 6) {
					that.nickname = tools.cache.get('mediakname');
				}
				else if (that.$store.state.app.nav_type === 8) {
					if (tools.cache.get('isArtLogin') == 1) {
						that.$store.commit('GET_CART_NUM');
					}
					that.nickname = tools.cache.get('artkname');
				}
			},

			getCoolartList() {
				let that = this;

				tools.ajax({
					url: '/api/gallery/navigation/bars',
					ajaxData: {},
					successFun: function (res) {

						for (let i of res.data.works_category) {
							i.active = false;
						}
						for (let i of res.data.gallery_tag) {
							i.active = false;
							for (let o of i.children) {
								o.active = false;
							}
						}

						for (let i of that.coolart_list) {
							if (i.name === '场景') {
								for (let o of res.data.gallery_tag) {
									if (o.id === 3) {
										for (let k of o.children) {
											k.url = '/coolart/goods/list';
											k.query = {gallery_tag_id: k.id, is_order_by_rank: 1};
											k.isSech = 1;
										}
										i.children = o.children;
									}
								}
							}
						}
						window.coolartData = res.data;
					},
					errorFun: function (error_data, status, headers, error_obj) {
						tools.alert.error(error_data.error_msg);
					},
					type: 'GET'
				});
			}
		},
		components: {},
		filters: {

		},
		watch: {
			'$route': 'isLinkChange',
			service_pop(val){
				if(val){
					this.getServiceContent();
				}
			}
		},
		mounted() {
			// console.log(this.$route.fullPath, 123123123)
			if (window.navList) {
				this.list = window.navList;
			}
			else {
				this.getList();
			}
			if (window.coolartData) {
				for (let i of this.coolart_list) {
					if (i.name === '场景') {
						for (let o of window.coolartData.gallery_tag) {
							if (o.id === 3) {
								i.children = o.children;
							}
						}
					}
				}
			}
			else {
				this.getCoolartList();
			}
			this.getData();
			let that = this;
			setTimeout(() => {
				if (that.$store.state.app.nav_type === 5 || that.$store.state.app.nav_type === 7) {
					that.nickname = tools.cache.get('nickname');
				}
				else if (that.$store.state.app.nav_type === 6) {
					that.nickname = tools.cache.get('mediakname');
				}
				else if (that.$store.state.app.nav_type === 8) {
					if (tools.cache.get('isArtLogin') == 1) {
						that.$store.commit('GET_CART_NUM');
					}
					that.nickname = tools.cache.get('artkname');
				}
			}, 500);

		}
	}
</script>



// WEBPACK FOOTER //
// Navigation.vue?19d14c2d